import {useCallback, useMemo} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {selectEnvelopes} from '~/CreateFabricInvitation/reducers/fabricTemplate/selectors';
import {
  selectEnvelopeId,
  selectHasEnvelopeChanged,
} from '~/CreateFabricInvitation/reducers/fabricDesign/selectors';
import {
  UPDATE_DESIGN_OPTIONS,
  RESET_DESIGN_OPTIONS,
} from '~/CreateFabricInvitation/reducers/fabricDesign/constants';

export const useEnvelope = () => {
  const dispatch = useDispatch();
  const envelopes = useSelector(selectEnvelopes);
  const envelopeId = useSelector(selectEnvelopeId);
  const hasEnvelopeChanged = useSelector(selectHasEnvelopeChanged);

  const onEnvelopeReset = useCallback(() => {
    dispatch({
      type: RESET_DESIGN_OPTIONS,
      payload: ['envelopeId'],
    });
  }, []);

  const onEnvelopeChange = useCallback(
    (icon) => {
      const selected = envelopes?.find((envelope) => envelope.icon === icon);
      dispatch({
        type: UPDATE_DESIGN_OPTIONS,
        payload: {envelopeId: selected.id, premiumFeaturesPristine: false},
      });
    },
    [envelopes]
  );

  const envelopeIcons = useMemo(() => envelopes?.map(({icon}) => icon), [envelopes]);

  const selectedEnvelope = useMemo(
    () => envelopes?.find(({id}) => id === envelopeId),
    [envelopes, envelopeId]
  );

  return {onEnvelopeChange, onEnvelopeReset, envelopeIcons, selectedEnvelope, hasEnvelopeChanged};
};
